/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import {
    IBuyboxCallbacks,
    IBuyboxData,
    IBuyboxProductConfigureDropdownViewProps,
    IBuyboxProductConfigureViewProps,
    IBuyboxProductQuantityViewProps,
    IBuyboxProps,
    IBuyboxState,
    IBuyboxViewProps
} from '@msdyn365-commerce-modules/buybox';
import { AttributeValue } from '@msdyn365-commerce/retail-proxy';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import { reaction } from 'mobx';
import * as React from 'react';
import { getRichTextHtml } from '@msdyn365-commerce/core';
import getAttributesForSelectedVariant, { AttributesForSelectedVariantInput } from '../../../data-actions/accordion/get-attributes-for-selected-variant';
import { IBuyboxProps as IBuyboxExtentionProps, IBuyboxResources as IBuyboxExtentionResources } from '../definition-extensions/buybox.ext.props.autogenerated';
import { Quantity } from '../utilities/quantity';
import { IBuyBoxData } from './buybox.data';
import AfterPayInfo from './components/afterpay_info';
import Sidebar from './components/sidebar';
import { getBuyboxFindInStore } from './components/buybox-find-in-store';
import { getBuyboxProductConfigure } from './components/buybox-product-configure';
import { getBuyboxAddToCart, getBuyboxProductAddToWishlist, getBuyboxProductDescription } from './components/buybox-small-components';
import LaybuyPriceBreakdown from './components/layBuyPriceBreakdown';
import PriceComponent from '../../../components/price-component';
export class BuyboxView extends React.PureComponent<IBuyboxViewProps & IBuyboxExtentionProps<IBuyboxData> & IBuyboxExtentionProps<IBuyBoxData>> {
    public componentDidMount() {
        setTimeout(function() {
            var containerEl = document.getElementsByClassName("msc-ss-carousel-vert-slide")[0];
            var elements = document.getElementsByClassName("msc-ss-carousel-vert-item");
            
            if (elements) {
                for (var i = 0; i< elements.length; i++) {
                    elements[i].addEventListener('click', (e: any) => {
                        containerEl.scrollTo({left: e.target.parentNode.closest(".msc-ss-carousel-vert-item").offsetLeft - 5, behavior: 'smooth'})
                    })

                }
            }
        }, 3000);
    }

    public render(): JSX.Element | null {
        const props = this.props;

        // @ts-ignore: Compiler not recognizing condition check for function params
        reaction(
            () => (props.data.product.result ? props.data.product.result.RecordId : null),
            () => {
                if (props.context && props.data.product.result) {
                    const actionInput = new AttributesForSelectedVariantInput(
                        props.data.product.result.RecordId,
                        // @ts-ignore
                        +props.context.actionContext.requestContext.apiSettings.channelId,
                        props.data.product.result
                    );
    
                    getAttributesForSelectedVariant(actionInput, props.context.actionContext).catch(error => {
                        props.telemetry.warning('Unable to update attributes for Product');
                        props.telemetry.error(error);
                    });
                }
            }
        );
        const configure= getBuyboxProductConfigure(props, props.state,props.callbacks);
        const { ModuleProps, MediaGalleryContainerProps, ProductInfoContainerProps, quantity, title, rating, callbacks, state, resources, slots } = props;
        const { productPrice } = props.data;

        const ChannelCountryRegionISOCode = props.data.channelConfiguration && props.data.channelConfiguration.result && props.data.channelConfiguration.result.ChannelCountryRegionISOCode;
        const prodPrice = productPrice && productPrice.result && productPrice.result.CustomerContextualPrice || 0;
        const productID = productPrice && productPrice.result && productPrice.result.ItemId || '';
        const isEnquireNow = productID.startsWith('CUS') || productID.startsWith('FWL') || productID.startsWith('EJP');
        const laybuyImageUrl = props.config.laybuyImageUrl ? props.config.laybuyImageUrl : 'https://files-ap-prod.cms.commerce.dynamics.com/cms/api/tstpxgfmq/binary/MB3JAm';
        const afterpayImage = props.config.afterpayImage ? props.config.afterpayImage : 'https://files-ap-prod.cms.commerce.dynamics.com/cms/api/hdrzssjspt/binary/MFsJR';
        const afterpaydesktopImg = props.config.afterpaydesktopImg ? props.config.afterpaydesktopImg : 'https://images-ap-prod.cms.commerce.dynamics.com/cms/api/hdrzssjspt/imageFileData/MFsHS';
        const afterpaymobileImg = props.config.afterpaymobileImg ? props.config.afterpaymobileImg : 'https://images-ap-prod.cms.commerce.dynamics.com/cms/api/hdrzssjspt/imageFileData/MFsHV';
    
        const price = productPrice && _getBuyboxProductPrice(props, productPrice.result);
        const hidePayLaterOptions = props.config.hidePayLaterOptions;
        const hideInStoreOptions = props.config.hideInStoreOptions;
        if (slots.giftCard) {
            return (
                <Module {...ModuleProps}>
                    {slots.giftCard}
                </Module>
            );
        }

        const productAttributes =props.data && props.data.productAttributes && props.data.productAttributes.result;
        const imageOrientationProperty = productAttributes &&
          props.data?.productAttributes?.result?.filter(p=> p.Name?.toLowerCase() === 'image orientation');
        const imageOrientation = imageOrientationProperty && imageOrientationProperty[0] ? imageOrientationProperty[0].TextValue! : 'portrait';

        const adjustedPrice = productPrice.result?.AdjustedPrice || 0;

        return (
            <Module {...ModuleProps}>
                <Node {...MediaGalleryContainerProps}>
                    <div className = {imageOrientation.toLowerCase()}>
                    {props.mediaGallery}
                    </div>
                </Node>
                <Node {...ProductInfoContainerProps}>
                    {title}
                    <div className="buybox-price">{price}</div>
                    { adjustedPrice < 2000 &&
                    ChannelCountryRegionISOCode && (
                    (isEnquireNow || hidePayLaterOptions) ? <div /> :
                    <Sidebar text={'view options'}>
                        {ChannelCountryRegionISOCode && !isEnquireNow &&
                            <AfterPayInfo
                                title={title}
                                price={prodPrice}
                                afterpayImage={afterpayImage}
                                afterpaydesktopImg={afterpaydesktopImg}
                                afterpaymobileImg={afterpaymobileImg}
                            />
                        }
                        {!isEnquireNow && ChannelCountryRegionISOCode === 'NZ' &&
                            <LaybuyPriceBreakdown
                                title={title}
                                price={prodPrice}
                                imageUrl={laybuyImageUrl}
                            />
                        }
                    </Sidebar>)}
                    {ChannelCountryRegionISOCode && (<div>{getBuyboxProductDescription(props)}</div>)}
    
                    {ChannelCountryRegionISOCode && _renderTextBlock(props.slots.textBlocks)}
                    {ChannelCountryRegionISOCode && slots.productAttributeLink}
                    {ChannelCountryRegionISOCode && rating}
                    {ChannelCountryRegionISOCode && quantity && _renderQuantity(quantity, callbacks, props, state, resources)}
                    {ChannelCountryRegionISOCode && configure && _renderConfigure(configure, props, state, callbacks)}
                    {ChannelCountryRegionISOCode && configure && _renderSku(configure, props)}
                    {hideInStoreOptions ? <div /> : (ChannelCountryRegionISOCode === 'NZ' &&_renderBuyboxFindInStore(props, state, callbacks))}
                    {ChannelCountryRegionISOCode && _renderCartAndWishlistDiv(props, state, callbacks)}
                    {ChannelCountryRegionISOCode && slots.productAttributeCompantionProduct}
                    {ChannelCountryRegionISOCode && _renderFreeShippingMessage(props, productAttributes)}
                    {ChannelCountryRegionISOCode === 'NZ' && slots.freightCharges}
                    {ChannelCountryRegionISOCode && slots.productEOQ}

                    {ChannelCountryRegionISOCode && slots.accordion}
                    {ChannelCountryRegionISOCode && slots.productPDFSpecification}
                    {ChannelCountryRegionISOCode && slots.lightbox}
                    {ChannelCountryRegionISOCode && slots.pageLink}
                    {ChannelCountryRegionISOCode && props.shopSimilarLook && _renderShopSimilarItem(props.shopSimilarLook)}
                </Node>
            </Module>
        );
    }
}
const _renderFreeShippingMessage = (props: IBuyboxViewProps & IBuyboxExtentionProps<IBuyboxData>, productAttributes: AttributeValue[] | undefined) => {    
    const freightItemAttr = productAttributes && productAttributes.find(attr => attr.Name === "Freight Item");
    if ((freightItemAttr && freightItemAttr.BooleanValue) || !props.config.freeShippingMessage) {
        return undefined;
    }
    /* @ts-ignore */
    const categoryPaths = props.data.categoryPaths && props.data.categoryPaths.result && props.data.categoryPaths.result;
    if (categoryPaths && categoryPaths[2] && categoryPaths[2].Name === "Furniture") {
        return undefined;
    }
    return (
        <div className='free-shipping-message'>
            <span dangerouslySetInnerHTML={getRichTextHtml(props.config.freeShippingMessage)} />
        </div>
    );
}

const _getBuyboxProductPrice = (props: any, productPrice: any)  => {
    const { id, typeName, context, resources } = props;
    // @ts-ignore
    return productPrice && (React.createElement(PriceComponent, { id: id, typeName: typeName, context: context, data: { price: productPrice }, freePriceText: resources.priceFree, originalPriceText: resources.originalPriceText, currentPriceText: resources.currentPriceText }));
}

const _renderTextBlock = (textBlocks: React.ReactNode[]): JSX.Element | undefined => {
    if (!textBlocks || textBlocks.length === 0) {
        return undefined;
    }

    return (
        <>
            {textBlocks[0]}
        </>
    );
};

const _renderCartAndWishlistDiv = (props: IBuyboxViewProps & IBuyboxExtentionProps<IBuyboxData>, state: IBuyboxState, callbacks: IBuyboxCallbacks): JSX.Element | undefined => {
    if (!props.addToWishlist) {
        return undefined;
    }
    const addToCart = getBuyboxAddToCart(props, state, callbacks);
    const addToWishList = getBuyboxProductAddToWishlist(props, state, callbacks);
    const estimatedDateProperty = props.data.productAvailableQuantity
        && props.data.productAvailableQuantity.result && props.data.productAvailableQuantity.result[0].ProductAvailableQuantity
        && props.data.productAvailableQuantity.result[0].ProductAvailableQuantity.ExtensionProperties
        && props.data.productAvailableQuantity.result[0].ProductAvailableQuantity.ExtensionProperties.find((property => property.Key === 'EstimatedDate'));

    const estimatedDateValue = estimatedDateProperty && estimatedDateProperty.Value && estimatedDateProperty.Value.StringValue;
    return (
        <div className='product-add-to-cart'>
            {estimatedDateValue ?
                <div className='product-add-to-cart-estimated-date'>Expected in Stock: <span className='estimated-date-value'>{estimatedDateValue}</span></div> : null}
            {addToCart && addToCart.errorBlock}
            {addToWishList?.errorBlock}
            <div className='buttons'>
                {addToCart && addToCart.button}
                {addToWishList?.button}
            </div>
        </div>
    );
};

const _renderBuyboxFindInStore = (props: IBuyboxViewProps & IBuyboxExtentionProps<IBuyboxData>, state: IBuyboxState, callbacks: IBuyboxCallbacks): JSX.Element | null => {
    const findInStore = getBuyboxFindInStore(props, state, callbacks);
    const { productPrice } = props.data;
    const uomSet = productPrice && productPrice.result && productPrice.result.UnitOfMeasure || '';
    let AvailabilitypProductTitleisSet = false;
    if(uomSet == 'SET4' || uomSet == 'SET6'){
        AvailabilitypProductTitleisSet = true;
    }
    return (
        findInStore ? (
        <Node {...findInStore.ContainerProps}>
            {findInStore.storeSelector}
            {findInStore.heading}
            {findInStore.description}
            {findInStore.errors}
            {AvailabilitypProductTitleisSet? <p>Availability: Please contact your local store for product availability.</p>: findInStore.button}
            {findInStore.modal}
        </Node>) : null
    );
};

const _renderConfigure = (configure: IBuyboxProductConfigureViewProps, props: IBuyboxViewProps & IBuyboxExtentionProps<IBuyboxData>, state: IBuyboxState, callbacks: IBuyboxCallbacks): JSX.Element | null => {
    const { ContainerProps } = configure;
    const dropdowns = getBuyboxProductConfigure(props, state, callbacks);
    if (dropdowns) {
        return (
            <Node {...ContainerProps}>
                {dropdowns.dropdowns.map(_renderConfigureDropdown)}
            </Node>
        );
    } else {
        return null;
    }
};

const _renderSku = (configure: IBuyboxProductConfigureViewProps, props: IBuyboxViewProps & IBuyboxExtentionProps<IBuyboxData> ): JSX.Element | null  => {
    const { ContainerProps } = configure;
    const { slots } = props;
    if (slots) {
        return (
            <Node {...ContainerProps}>
                {slots.productSKU}
            </Node>
        );
    } else {
        return null;
    }
}

const _renderConfigureDropdown = (dropdown: IBuyboxProductConfigureDropdownViewProps): JSX.Element => {
    const { ContainerProps, LabelContainerProps, heading, errors, select } = dropdown;
    return (
        <Node {...ContainerProps}>
            <Node {...LabelContainerProps}>
                {heading}
                {errors}
            </Node>
            {select}
        </Node>
    );
};

const _renderShopSimilarItem = (shopSimilarItem: any) => {
    const { ContainerProps, errors, input } = shopSimilarItem;
    return (React.createElement(Node, Object.assign({}, ContainerProps),
        errors,
        input));
};

const _renderQuantity = (quantityComponent: IBuyboxProductQuantityViewProps, callbacks: IBuyboxCallbacks, props: IBuyboxProps<IBuyboxData>, state: IBuyboxState, extentionResources: IBuyboxExtentionResources): JSX.Element | null => {
    const { ContainerProps, LabelContainerProps, heading, errors } = quantityComponent;

    const {
        resources,
        context: {
            app: {
                config: {
                    maxQuantityForCartLineItem
                }
            }
        }
    } = props;

    const
        {
            quantity,
        } = state;

    const isProductAvailable: boolean = props.data.productAvailableQuantity.result && props.data.productAvailableQuantity.result[0] &&
        props.data.productAvailableQuantity.result[0].IsProductAvailable || false;

    if (isProductAvailable) {
        const maxQuantity = props.data.productAvailableQuantity.result &&
            props.data.productAvailableQuantity.result[0] &&
            props.data.productAvailableQuantity.result[0].ProductAvailableQuantity.AvailableQuantity || maxQuantityForCartLineItem;

        const onChange = (newValue: number) => {
            if (callbacks.updateQuantity) {
                callbacks.updateQuantity(newValue);
            }
        };

        return (
            <Node {...ContainerProps}>
                <Node {...LabelContainerProps}>
                    {heading}
                    {errors}
                </Node>

                <Quantity
                    id='ms-buybox__product-quantity-input'
                    max={maxQuantity || 10}
                    currentCount={quantity}
                    onChange={onChange}
                    inputQuantityAriaLabel={resources.inputQuantityAriaLabel}
                    decrementButtonAriaLabel={extentionResources.decrementButtonAriaLabel}
                    incrementButtonAriaLabel={extentionResources.incrementButtonAriaLabel}
                />
            </Node>
        );
    }
    return <Node {...ContainerProps} />;
};

export default BuyboxView;
